import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from '../../Home/register/register';

@Component({
  selector: 'app-manufacturing-hero',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './manufacturing-hero.html',
  styleUrls: ['./manufacturing-hero.css'],
})
export class ManufacturingHeroComponent {
  showRegister = false;
  manufacturingApp = [{ name: 'Manufacturing', image: 'images/webps/manufacturing.svg' }];
}
